import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from 'react-redux';
import { updateCustomer } from "../../slices/customers";
import useModal from "../../hooks/modal";
import ErrorModal from "../error-modal";

const CustomerUpdate = ({ customer }) => {

    let timer = null;

    const dispatch = useDispatch()
    const [isShowingErrorModal, toggleErrorModal] = useModal();

    const onSubmit = (data) => {
        Promise.resolve(dispatch(updateCustomer({ customerId: customer.id, args: data })))
            .then(data => {
                if (data.error) {
                    toggleErrorModal(true)
                }
            })
    }

    const {
        register,
        handleSubmit,
        reset,
        watch,
        setValue,
        formState: {
            errors,
            isDirty,
        }
    } = useForm({
        defaultValues: {
            name: customer?.name,
            customer_reference: customer?.customer_reference,
            email: customer?.email,
            phone: customer?.phone,
            address: customer?.address
        }
    });

    useEffect(() => {
        if (customer) {
            reset({
                name: customer?.name,
                customer_reference: customer?.customer_reference,
                email: customer?.email,
                phone: customer?.phone,
                address: customer.address,
            })

        }
    }, [customer])

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <ErrorModal
                showError={isShowingErrorModal}
                toggle={toggleErrorModal}
            />

            <div className="row align-items-end">
                <div className="col-md-8 mb-4">
                    <h2>{gettext('Customer')}</h2>
                    <input type="text" {...register("name")} className="form-control" />
                </div>
                <div className="col-md-4 mb-4">
                    <label>{gettext('Customer reference')}</label>
                    <input type="text" {...register("customer_reference")} className="form-control" />
                </div>
            </div>
            <div className="row">
                <div className="col-md-8 mb-4">
                    <label>{gettext('Email')}</label>
                    <input type="text" {...register("email")} className="form-control" />
                </div>
                <div className="col-md-4 mb-4">
                    <label>{gettext('Phone number')}</label>
                    <input type="text" {...register("phone")} className="form-control" />
                </div>
            </div>
            <div className="row">
                <div className="col-md-6 col-12 mb-4">
                    <label>{gettext('Address')}</label>
                    <input type="text" {...register("address.address_1")} className="form-control" />
                </div>
                <div className="col-md-2 col-4 mb-4">
                    <label>{gettext('Zip code')}</label>
                    <input type="text" {...register("address.zip_code")} className="form-control" />
                </div>
                <div className="col-md-4 col-8 mb-4">
                    <label>{gettext('City')}</label>
                    <input type="text" {...register("address.city")} className="form-control" />
                </div>
                <div className="col-md-6 mb-4">
                    <label>{gettext('Address 2')}</label>
                    <input type="text" {...register("address.address_2")} className="form-control" />
                </div>
                <div className="col-md-6 mb-4">
                    <label>{gettext('Address 3')}</label>
                    <input type="text" {...register("address.address_3")} className="form-control" />
                </div>
            </div>
            {isDirty &&
                <div className="save-button-container text-end">
                    <input className="btn btn-primary btn-sm mt-4 ms-auto" type="submit" value={gettext("Save")} />
                </div>
            }
        </form>
    )
}

export default CustomerUpdate